import { useParams } from 'react-router-dom';
import CloverCardForm from '../components/CreditCard/CloverCardForm';


import { getLabConfig } from '../utils/api';


function CCiFrame() {
	/*const callingURL=window.location.href;
	const URLArray=callingURL.split('/');
	console.log(URLArray);
	const amt = URLArray[4]*/
	const urlParams = useParams();
	const amount = urlParams.amt;
	const email = urlParams.email;
	const fname = urlParams.fname;
	const lname = urlParams.lname;
	const refid = urlParams.refid
	console.log("amt",amount);
	return (
	<div>
		<CloverCardForm amount={amount} email={email} fname={fname} lname={lname} refid={refid}/>
	</div>
	)
;}

export default CCiFrame;


